import { Box, Typography, LinearProgress } from "@mui/material";
import React, { FC, useEffect } from "react";



export interface LinearProgressBarProperties {
    progress: number
    color?: "primary" | "secondary"
}

const LinearProgressBar: FC<LinearProgressBarProperties> = ({
    progress,
    color
}) => {
    return <>
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" value={progress} color={color} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">{`${Math.round(progress,)}%`}</Typography>
            </Box>
        </Box>
    </>
}

export { LinearProgressBar }